module.exports = __webpack_public_path__ + "assets/images/survey-banner.svg?v=0782a5a3";